import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const GatePassFeedLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'StudentProfileGatePass' */ './components/GatePassFeed'
		)
);

export default () => ({
	path: 'gate-pass',
	element: <AsyncLoading component={<GatePassFeedLazy />} />,
});
